/**
 * Created by jacmai on 3/8/2017.
 */
define([
  "backbone",
  "underscore",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "../actionItemModal/apiRequestValidation/apiRequestValidationModel",
], function (Backbone, _, $, Messenger, Properties, ApiRequestValidationModel) {
  var ActionGroupItems = {};

  ActionGroupItems.apiRequest = Backbone.Model.extend({
    idAttribute: "actionId",
    defaults: {
      order: 0,
      actionType: 1,
      httpMethod: "GET",
      apiId: -1,
      path: "",
      requestBody: "",
    },
    defaultValidateAttributes: ["apiId", "path", "requestBody"],
    getResponseVariables: function () {
      return this.get("responseVariables") || [];
    },
    addResponseVariable: function (element, variableId) {
      //clone the array and add the new value, then set the new array as an attribute.  We clone the array
      // because it allows us to modify the array of a cloned model without modifying the array in the original
      // model. Otherwise, performing direct modifications on the array would modify the original model.
      var responseVariables = this.getResponseVariables().slice(0);
      responseVariables.push({ element: element, conversationVariableId: variableId });
      this.set("responseVariables", responseVariables);
    },
    removeResponseVariable: function (variableId) {
      //since a variable can only be mapped to one response element, we only need to search by variable Id
      this.set(
        "responseVariables",
        this.getResponseVariables().filter(function (item) {
          return item.conversationVariableId !== variableId; //keep items not matching the variable Id
        }),
      );
    },
    display: function (variables) {
      var apiModel = this.apis.get(this.get("apiId"));
      if (apiModel) {
        var apiName = apiModel.get("name");
      }
      return (
        "Request <b>" +
        apiName +
        "</b> - <i>" +
        this.get("httpMethod") +
        "</i> " +
        parseVariablesInString(this.get("path"), variables, true)
      );
    },
    getAllVariableIds: function () {
      //collect all variables (types not tokens) from the path and body and return them in a list
      //use an object as a pseudo set by using the variable Ids as keys and a constant as the value
      var variableSet = {};
      [this.get("path"), this.get("requestBody")].forEach(function (text) {
        text.replace(/{\d+}/g, function (match) {
          variableSet[parseInt(match.slice(1, -1), 10)] = true;
        });
      });
      return _.keys(variableSet);
    },
    getParsedRequestPath: function (variables) {
      return parseVariablesInString(this.get("path"), variables);
    },
    getParsedRequestBody: function (variables) {
      return parseVariablesInString(this.get("requestBody"), variables);
    },
    getTestResults: function () {
      return this.testRequestModel;
    },
    setRequestPath: function (path, variables) {
      this.set("path", replaceVariableNamesInString(path, variables));
    },
    setRequestBody: function (body, variables) {
      this.set("requestBody", replaceVariableNamesInString(body, variables));
    },
    testRequest: function (testVariables) {
      this.testRequestModel = new ApiRequestValidationModel.testRequest();
      this.testRequestModel.testApiRequest(this, testVariables);
      return this.testRequestModel;
    },
    validateAttribute: function (attribute, value) {
      if (attribute === "apiId") {
        if (value <= 0) return $.t("actions.items.apiRequest.missingApi");
      }
      if (attribute === "path") {
        return this.validateRequiredValue(value, { maxLength: 200 });
      }
      if (attribute === "requestBody") {
        return this.validateStringLength(value, { maxLength: 1000 });
      }
    },
    urlRoot: function () {
      return this.collection.url() + "/apirequest";
    },
  });

  ActionGroupItems.apiRequests = Backbone.Collection.extend({
    model: ActionGroupItems.apiRequest,
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/actiongroup/" + this.actionGroupId + "/apirequest";
    },
  });

  ActionGroupItems.transformation = Backbone.Model.extend({
    idAttribute: "actionId",
    isComplex: false,
    firstExpression: "",
    secondExpression: "",
    defaults: {
      order: 0,
      actionType: 0,
      conversationVariableId: -1,
      expression: {
        value: "",
      },
    },
    defaultValidateAttributes: ["conversationVariableId", "expression"],
    display: function (variables) {
      const variableModel = variables.get(this.get("conversationVariableId"));
      let variableName;
      if (variableModel) {
        variableName = variableModel.get("name");
      } else {
        variableName = "VARIABLE";
      }
      const variableHtml = '<span class="action-variable">' + variableName.escapeHtml() + "</span>";
      return (
        "Set " +
        variableHtml +
        " to " +
        parseVariablesInString(parseOperators(this.get("expression").value), variables, true)
      );
    },
    getParsedVariable: function (variables) {
      return parseVariablesInString(
        "{" + String(this.get("conversationVariableId") + "}"),
        variables,
      ).replace(/[{}]/g, "");
    },
    getParsedExpression: function (variables) {
      return parseExpression(this.get("expression").value, variables, true).replace(/[{}]/g, "");
    },
    getParsedSecondExpression: function (variables) {
      return parseExpression(this.get("expression").value, variables, false).replace(/[{}]/g, "");
    },
    getOperator: function () {
      return getExpressionOperator(this.get("expression").value);
    },
    setComplexExpression: function (isComplex) {
      this.isComplex = isComplex;
    },
    setFirstExpression: function (expression, variables) {
      this.firstExpression = replaceVariableNameInExpression(expression, variables);
    },
    setSecondExpression: function (expression, variables) {
      this.secondExpression = replaceVariableNameInExpression(expression, variables);
    },
    setConversationVariableId: function (variableName, variables) {
      this.set("conversationVariableId", replaceVariableName(variableName, variables));
    },
    setExpression: function (expression, secondExpression, operator, variables) {
      this.set("expression", {
        value: processExpression(expression, secondExpression, operator, this.isComplex, variables),
      });
    },
    _validateComplexExpression: function () {
      //if using a complex expression, make sure the expressions are either a number or variable, no strings
      if (this.isComplex) {
        if (!isValidExpression(this.firstExpression, this.secondExpression)) {
          return $.t("actions.items.transformation.invalidComplexExpression");
        }
      }
    },
    validateAttribute: function (attribute, value) {
      if (attribute === "conversationVariableId") {
        if (value <= 0) return $.t("actions.items.transformation.invalidVariable");
      }
      if (attribute === "expression") {
        return (
          this.validateRequiredValue(value.value, { maxLength: 500 }) ||
          this._validateComplexExpression()
        );
      }
    },
    urlRoot: function () {
      return this.collection.url() + "/transformation";
    },
  });

  ActionGroupItems.transformations = Backbone.Collection.extend({
    model: ActionGroupItems.transformation,
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return (
        Properties.rootURL + "/" + kbId + "/actiongroup/" + this.actionGroupId + "/transformation"
      );
    },
  });

  ActionGroupItems.actionItemsCol = Backbone.Collection.extend({
    comparator: "order",
    initializeCustom: function () {
      this.on(
        "destroy",
        function (removedModel) {
          //when an item is removed from the action items, shift the order of all items after it by one
          this.forEach(function (item) {
            if (removedModel.get("order") < item.get("order")) {
              item.set("order", item.get("order") - 1);
            }
          }, this);
        },
        this,
      );
    },
    addItem: function (item) {
      //set the order of the new item to be at the end of the items list
      item.set("order", this.length);
      this.add(item);
    },
    fetch: function (actionGroupId) {
      //override default fetch implementation by fetching two different collections and combining the results
      this.actionGroupId = actionGroupId;
      const apiRequests = new ActionGroupItems.apiRequests();
      apiRequests.actionGroupId = actionGroupId;
      apiRequests.fetch();
      const transformations = new ActionGroupItems.transformations();
      transformations.actionGroupId = actionGroupId;
      transformations.fetch();
      //fake the events that take place as part of a real server request
      this.trigger("request");
      apiRequests.onSynced(function () {
        transformations.onSynced(function () {
          this.add(apiRequests.models, { silent: true });
          this.add(transformations.models, { silent: true });
          //associate the items with the new collection
          this.forEach(function (item) {
            item.collection = this;
          }, this);
          this.trigger("fetched");
          this.trigger("sync");
        }, this);
      }, this);
    },
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/actiongroup/" + this.actionGroupId;
    },
  });

  /**
   * Replaces variable Id references with the variable's name.  Optionally wrap the names in span tags
   * @param string String containing variable Ids in braces
   * @param variables Collection of all variables
   * @param htmlWrap Wrap the variables in span tags
   */
  function parseVariablesInString(string, variables, htmlWrap) {
    return string.replace(/{\d+}/g, function (match) {
      match = parseInt(match.slice(1, -1), 10); //slice out the braces and parse as an integer
      const variableObj = variables.get(match);
      let variableName;
      if (variableObj) {
        variableName = variableObj.get("name");
      } else {
        variableName = "VARIABLE";
      }
      if (htmlWrap) {
        return '<span class="action-variable">' + variableName.escapeHtml() + "</span>";
      }
      return "{" + variableName + "}";
    });
  }

  /**
   * Parses any variables found in the simple or complex expression
   * @param input String containing the expression
   * @param variables Collection of all variables
   * @param isFirstExpression True if evaluating the first expression input box, false if evaluating the second
   */
  function parseExpression(input, variables, isFirstExpression) {
    //check if an operator is present
    var expArray = input.split(/[+\-*/]/);

    if (expressionContainsNegativeNumbers(input)) {
      if (isFirstExpression) {
        return parseVariablesInString(
          parseExpressionWithNegativeNumber(input, true).replace(/"/g, ""),
          variables,
          false,
        );
      } else {
        return parseVariablesInString(
          parseExpressionWithNegativeNumber(input, false).replace(/"/g, ""),
          variables,
          false,
        );
      }
    } else if (input < 0 || expArray.length !== 2 || isSimpleExpressionWithOperator(input)) {
      if (isFirstExpression) {
        return parseVariablesInString(input.replace(/"/g, ""), variables, false);
      } else {
        return ""; //second expression currently not used, so return nothing
      }
    } else {
      if (isFirstExpression) {
        return parseVariablesInString(expArray[0].trim().replace(/"/g, ""), variables, false);
      } else {
        return parseVariablesInString(expArray[1].trim().replace(/"/g, ""), variables, false);
      }
    }
  }

  /**
   * Processes the simple or complex expression. This includes replacing any conversation variables with their IDs,
   * wrapping any string values in quotes, and appending the operator when using a complex expression
   * @param firstExpression String containing expression or first part if complex
   * @param secondExpression String containing second part of expression if complex
   * @param operator +,-,*,/ if is expression is complex or blank if using a simple expression
   * @param isComplex True if processing a complex expression
   * @param variables Collection of all variables
   */
  function processExpression(firstExpression, secondExpression, operator, isComplex, variables) {
    //check if an operator was used
    if (!isComplex) {
      //simple expression, so ignore the secondExpression and operator fields
      return replaceVariableNameInExpression(firstExpression, variables);
    } else {
      return (
        replaceVariableNameInExpression(firstExpression, variables) +
        " " +
        operator +
        " " +
        replaceVariableNameInExpression(secondExpression, variables)
      );
    }
  }

  /**
   * Evaluates the complex expression to make sure two parts contain either a number or conversation variable
   * @param firstExpression String containing the first part of the expression
   * @param secondExpression String containing the second part of the expression
   */
  function isValidExpression(firstExpression, secondExpression) {
    var isValid = true;

    //check each part of the expression to be either a number or conversation variable
    //at this point, text entries will be wrapped in quotes, so check for any present
    if (firstExpression.length === 0 || secondExpression.length === 0) {
      isValid = false;
    }
    if (isNaN(firstExpression)) {
      if (firstExpression.indexOf('"') !== -1) {
        isValid = false;
      }
    }
    if (isNaN(secondExpression)) {
      if (secondExpression.indexOf('"') !== -1) {
        isValid = false;
      }
    }

    return isValid;
  }

  /**
   * Checks if the expression is a simple transformation that contains one or more of the operator characters (such as "12/31/1999").
   * For this we'll check if quotes exist only at the very beginning and end of the un-split expression.
   * @param expression String containing simple or complex expression
   */
  function isSimpleExpressionWithOperator(expression) {
    return expression.match(/^"[^"]*"$/);
  }

  /**
   * Checks if the expression contains one or more negative numbers (such as {Test Var} * -5).
   * This must be done before breaking apart and parsing the expression since the negative numbers will be mistaken as
   * the minus operator.
   * @param expression String containing simple or complex expression
   */
  function expressionContainsNegativeNumbers(expression) {
    var firstNegative = expression.match(/^-[0-9]+\s[+\-*/]\s(\{[0-9]+}|[0-9]+)$/); // First part of expression has negative number
    var secondNegative = expression.match(/^(\{[0-9]+}|[0-9]+)\s[+\-*/]\s-[0-9]+$/); // Second part of expression has negative number
    var bothNegative = expression.match(/^-[0-9]+\s[+\-*/]\s-[0-9]+$/); // Both parts of expression are negative numbers
    return firstNegative || secondNegative || bothNegative;
  }

  /**
   * Handles returning the first or second part of the complex expression containing negative numbers. Splitting the
   * expression by the operator would break it into multiple pieces without the negative number, so the regular expressions
   * will check for that first and grab the correct parts with the negative number intact.
   * @param expression String containing complex expression
   * @param isFirstPart True if evaluating the first part of the complex expression, false if evaluating the second part
   */
  function parseExpressionWithNegativeNumber(expression, isFirstPart) {
    var expArray = expression.split(/[+\-*/]/);

    if (expression.match(/^-[0-9]+\s[+\-*/]\s(\{[0-9]+}|[0-9]+)$/)) {
      //first part contains negative number
      if (isFirstPart) {
        return "-" + expArray[1].trim();
      } else {
        return expArray[2].trim();
      }
    } else if (expression.match(/^(\{[0-9]+}|[0-9]+)\s[+\-*/]\s-[0-9]+$/)) {
      //second part contains negative number
      if (isFirstPart) {
        return expArray[0].trim();
      } else {
        return "-" + expArray[2].trim();
      }
    } else {
      //both parts contain negative number
      if (isFirstPart) {
        return "-" + expArray[1].trim();
      } else {
        return "-" + expArray[3].trim();
      }
    }
  }

  /**
   * Returns the operator (+,-,*,/) in the complex expression or blank if not found
   * @param expression String containing expression
   */
  function getExpressionOperator(expression) {
    if (isSimpleExpressionWithOperator(expression)) {
      return ""; //simple expression, no return nothing
    } else if (expressionContainsNegativeNumbers(expression)) {
      return getOperatorOfNegativeExpression(expression);
    } else if (expression.indexOf("+") !== -1) {
      return "+";
    } else if (expression.indexOf("-") !== -1) {
      return "-";
    } else if (expression.indexOf("*") !== -1) {
      return "*";
    } else if (expression.indexOf("/") !== -1) {
      return "/";
    } else {
      return ""; //no operator found, so return nothing for now
    }
  }

  /**
   * Returns the operator of the expression that contains negative numbers
   * It uses regex to grab the correct operator and not mistake the negative for a minus
   * @param expression String containing expression
   */
  function getOperatorOfNegativeExpression(expression) {
    //this will grab the operator plus the negative(s) used in the expression
    var operatorMatch = expression.match(/[+\-*/]+/g);

    if (expression.match(/^-[0-9]+\s[+\-*/]\s(\{[0-9]+}|[0-9]+)$/)) {
      //first part contains negative number
      return operatorMatch[1];
    } else if (expression.match(/^(\{[0-9]+}|[0-9]+)\s[+\-*/]\s-[0-9]+$/)) {
      //second part contains negative number
      return operatorMatch[0];
    } else {
      //both parts contain negative number
      return operatorMatch[1];
    }
  }

  /**
   * Replaces the Variable name with their Id or -1 if not found.
   * @param string String containing variable name
   * @param variables Collection of all variables
   */
  function replaceVariableName(string, variables) {
    var variableObj = variables.findWhere({ name: string });
    if (variableObj) {
      return variableObj.id;
    } else {
      return -1;
    }
  }

  /**
   * Replaces Variable names with their Id if found. If not found, will wrap the value in quotes if its a string
   * @param string String containing either the variable names, text value, or numeric value
   * @param variables Collection of all variables
   */
  function replaceVariableNameInExpression(input, variables) {
    var variableObj = variables.findWhere({ name: input });
    if (variableObj) {
      return "{" + variableObj.id + "}"; //variable in expression needs to be wrapped in braces
    } else {
      //since the expression isn't a variable, check if it's either a string or number
      //if it's a string, wrap it in quotes
      //also make sure the input isn't 'Infinity' since JavaScript interprets it as a number
      if (isNaN(input) || input === "Infinity") {
        input = '"' + input + '"';
      }
      return input;
    }
  }

  /**
   * Replace all Variable names in braces with their variable Ids.
   * @param string String containing variable names in braces
   * @param variables Collection of all variables
   */
  function replaceVariableNamesInString(string, variables) {
    return string.replace(/{[\w ]+}/g, function (match) {
      var variableName = match.slice(1, -1); //slice out the braces
      var variableObj = variables.findWhere({ name: variableName });
      if (variableObj) {
        return "{" + variableObj.id + "}";
      } else {
        return match; //leave element unchanged
      }
    });
  }

  function parseOperators(expression) {
    //not a string assignment, so it is a mathematical expression
    if (!expression.includes('"')) {
      return expression.replace("*", "&times;").replace("/", "&divide;");
    }
    return expression;
  }

  return ActionGroupItems;
});
